import { ApplicationId, VERSION_PLACEHOLDER } from '@nx-customer-apps/components';
import { Environment } from './environment.model';

export const environment: Environment = {
    applicationName: 'Planning Tools Config',
    serviceWorker: true,
    production: true,
    environment: 'staging',
    accountAppUrl: 'https://account-staging.viessmann-climatesolutions.com',
    userResultUrl: 'https://api-staging.viessmann-climatesolutions.com/users/v1/users/me?sections=identity&sections=roles',
    baseUrl: 'https://api-staging.viessmann-climatesolutions.com',
    partnerPortalBaseUrl: 'https://partnerportal-staging.viessmann-climatesolutions.com',
    translationsBaseUrl: 'https://api-staging.viessmann-climatesolutions.com/translations/v2',
    apiKey: '68ddc22a-29e7-4d7b-b0fa-57112c38b02c',
    phraseappProjectId: {
        homePlanner: '8e2aa2a65cc63ba26a928b36582552c8',
        globalHeader: '30b1afd8a62ba6728e53abffe9101eb2',
        designSystemWeb: 'ec38b083a23c58c604a49d7f443dd7f2',
        planningToolsConfig: '68526a387ed814922648f480259a4774',
        questionFlow: '5cfb7f9a03a8d6fba82d29aa840b7715',
        components: '31fb8c95c8f4afd6c68b63a48b96116b'
    },
    authConfig: {
        issuer: 'https://iaml2.viessmann-climatesolutions.com',
        loginUrl: 'https://iaml2.viessmann-climatesolutions.com/idp/v3/authorize',
        logoutUrl: 'https://iaml2.viessmann-climatesolutions.com/idp/v3/sso/logout',
        tokenEndpoint: 'https://iaml2.viessmann-climatesolutions.com/idp/v3/token',
        userinfoEndpoint: 'https://iaml2.viessmann-climatesolutions.com/idp/v2/tokeninfo',
        redirectUri: 'https://planning-tools-config-staging.viessmann-climatesolutions.com',
        clientId: '59a08fbc34003055294f50b884a6bcf3',
        postLogoutRedirectUri: '',
        responseType: 'code',
        scope: 'Internal offline_access',
        oidc: false,
        clockSkewInSec: 0
    },
    apiPlanningProjectsConfig: {
        apiBaseUrl: 'https://api-staging.viessmann-climatesolutions.com/planning-projects/v1',
        applicationId: ApplicationId.ConfigurationPortal
    },
    vapi: {
        baseUrl: 'https://api-staging.viessmann-climatesolutions.com',
        entrypoint: `/planning-projects/${VERSION_PLACEHOLDER}`,
        version: 'v1'
    },
    storageKeys: {
        locale: 'locale'
    }
};
